enum AppLanguage {
    RO = "ro",
    EN = "en",
    IT = "it",
    DE = "de",
    FR = "fr",
    ES = "es",
    HU = "hu"
}

export default AppLanguage;